import ColoringParticle from "./ColoringParticle";

export default class PlayerDrawing extends Phaser.Sprite
{
    constructor(game, config, brush, canvas, isDebug)
    {
        super(game);
        this.config = config;
        this.brush = brush;
        this.canvas = canvas;
        this.requiredCompletion = this.config.requiredCompletion;
        if (isDebug)
        {
            this.requiredCompletion = this.config.requiredCompletionDebug;
        }

        this.step = this.config.completionCheckStepDistance;
        this.totalChecks = (this.canvas.height / this.step) * (this.canvas.height / this.step);
        this.canvas.onDraw.add(this.checkCompletion, this);

        // Check intermittently for completion.
        this.completionCheckTimer = this.game.time.create(false);
        this.completionCheckTimer.loop(Phaser.Timer.SECOND / 2, this.checkCompletion, this);
        this.completionCheckTimer.start();

        this.onComplete = new Phaser.Signal();

        this.game.physics.startSystem(Phaser.Physics.ARCADE);
        this.emitter = this.game.add.emitter(0, 0, 50);
        this.emitter.particleClass = ColoringParticle;
        this.emitter.makeParticles(["particle_1", "particle_2", "particle_3"]);
        this.emitter.setAlpha(1, 0, 1500, Phaser.Easing.Sinusoidal.Out);
        this.emitter.setXSpeed(-200, 200);
        this.emitter.setYSpeed(-200, 200);
        this.emitter.setScale(0.35, 1, 0.35, 1, 400, Phaser.Easing.Linear.None);
        this.emitter.setRotation(0,0);
        this.emitter.gravity = 0;
        this.emitter.start(false, 1600, 25);
        this.emitter.on = false;

        this.crayon = this.game.add.sprite(0, 0, "crayon");
        this.crayon.anchor.setTo(0.5, 1);
        this.crayon.angle = 30;
        this.cursorStyle = document.getElementById("container").style.cursor;

        this.finished = false;
    }

    update()
    {
        if(this.finished) return;

        document.getElementById("container").style.cursor = "none";
        this.brush.position.set(this.game.input.x, this.game.input.y);
        this.crayon.position.set(this.game.input.x, this.game.input.y);
        this.emitter.emitX = this.game.input.x;
        this.emitter.emitY = this.game.input.y;

        if(this.alive && this.canvas.drewThisFrame)
        {
            this.emitter.on = this.game.input.x > this.canvas.x && this.game.input.x < this.canvas.x + this.canvas.width
                           && this.game.input.y > this.canvas.y && this.game.input.y < this.canvas.y + this.canvas.height;
        }
        else
        {
            this.emitter.on = false;
        }
    }

    // Checks a reasonable subset of pixels on the mask to see if enough of them have been coloured.
    checkCompletion()
    {
        let completion = 1;
        let failedPixelReduction = -1 / this.totalChecks;
        let x = this.step;
        let y = this.step;
        let pixel = Phaser.Color.createColor();

        while(y < this.canvas.height)
        {
            while(x < this.canvas.width)
            {
                this.canvas.bitmapData.getPixel(x, y, pixel);

                if(pixel.r == 255 && pixel.g == 255 && pixel.b == 255)
                {
                    // This pixel hasn't been coloured yet.
                    completion += failedPixelReduction;

                    if(completion < this.requiredCompletion)
                    {
                        // There are too many uncoloured pixels to have possibly passed the requirement
                        return;
                    }
                }

                x += this.step;
            }

            x = this.step;
            y += this.step;
        }

        // Reaching here means enough pixels were coloured to pass the requirement
        this.completionCheckTimer.stop();
        this.completionCheckTimer.destroy();
        this.onComplete.dispatch();
        this.emitter.on = false;
        this.kill();
    }

    finish()
    {
        this.finished = true;
        this.crayon.kill();
        document.getElementById("container").style.cursor = this.cursorStyle;
    }

    destroy(children)
    {
        this.canvas = null;
        this.brush = null;
        this.emitter.destroy(true, false);
        this.crayon.destroy();
        this.emitter = null;
        this.crayon = null;
        delete this.config;
        document.getElementById("container").style.cursor = this.cursorStyle;
        super.destroy(children);
    }
}
